import { Global } from '@emotion/react'
import { theme } from '@/config'

export const GlobalStyle = () => <Global
  styles={{
    '*': {
      boxSizing: 'border-box',
      padding: 0,
      margin: 0,
    },

    'html': {
      overflowX: 'hidden',
      padding: 0,
      margin: 0,
    },

    'body': {
      overflowX: 'hidden',
      padding: 0,
      margin: 0,
    },

    // @spec FR-0077/AC-6@v1 — quoted-message jump-to highlight.
    '.str-chat__channel .message-highlighted': {
      animation: 'highlightMessage 2s ease-in-out',
    },
    '@keyframes highlightMessage': {
      '0%': { backgroundColor: 'transparent' },
      '15%': { backgroundColor: theme.baseColors.neutralSolid200 },
      '85%': { backgroundColor: theme.baseColors.neutralSolid200 },
      '100%': { backgroundColor: 'transparent' },
    },
  }}
/>
